import { combineReducers } from 'redux';
import manageDeleted from './manageDeleted';

export default combineReducers({ manageDeleted });
